import * as React from "react";
import title from "assets/images/title.svg";
import audition from "assets/images/audition.png";
import finalist from "assets/images/finalist.png";
import bgPreview from "assets/images/bg-preview.png";
import logo from "assets/images/logo.png";
import logoMeta from "assets/images/metaverse-logo.svg";
import bgTop from "assets/images/bg-top.png";
import userList from "assets/images/user-list.png";
import buttonDetail from "assets/images/button-detail.svg";
import buttonDetailEn from "assets/images/button-detail-en.svg";
import avatar1 from "assets/images/avatar1.png";
import avatar2 from "assets/images/avatar2.png";
import avatar3 from "assets/images/avatar3.png";
import avatar4 from "assets/images/avatar4.png";
import avatar5 from "assets/images/avatar5.png";
import mic from "assets/images/mic.png";
import bgAudition from "assets/images/bg-audition.svg";
import bgFlow from "assets/images/bg-flow.svg";
import bgFlowEn from "assets/images/bg-flow-en.svg";
import buttonVote from "assets/images/button-vote.svg";
import bgWinner from "assets/images/bg-winner.png";
import titleEn from "assets/images/title-sm-en.svg";
import gemieLogo from "assets/images/genie.png";
import Profile from "./Profile";
import buttonVoteEn from "assets/images/vote-sm-en.svg";
import Footer from "./Footer";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
const Image = ({ src, alt, className, onClick }) => (
  <img
    loading="lazy"
    src={src}
    alt={alt}
    className={className}
    onClick={onClick}
  />
);

const Finalist = ({ src, alt, name, language, scroll }) => {
  const scrollUp = () => {
    const element = document.getElementById(name);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div className="flex flex-col">
      <div className="self-center finalist-text font-semibold text-white rounded-full bg-[#6A43B8] w-full text-center my-5">
        {name}
      </div>
      <Image src={src} alt={alt} className="w-[220px]" />
      <Image
        src={language === "en" ? buttonDetailEn : buttonDetail}
        alt={alt}
        className={"w-[111px] h-[35px] mx-auto my-5 cursor-pointer"}
        onClick={() => scrollUp()}
      />
    </div>
  );
};

function HomeMobile() {
  const { t, i18n } = useTranslation();
  const [language, setlanguage] = React.useState("en");
  const isEn = language === "en" ? true : false;

  const finalists = [
    {
      src: avatar1,
      alt: "小虎",
      name: isEn ? "Kotora" : "小虎",
      scroll: 2600,
    },
    {
      src: avatar2,
      alt: "すず",
      name: isEn ? "Suzu" : "すず",
      scroll: 3800,
    },
    {
      src: avatar3,
      alt: "しんや",
      name: isEn ? "Shinya" : "しんや",
      scroll: 5000,
    },
    {
      src: avatar4,
      alt: "浪花明音　アカンネ〜",
      name: isEn ? "Akane Naniwa" : "浪花明音　アカンネ〜",
      scroll: 6400,
    },
    {
      src: avatar5,
      alt: "あんじ／ANGEL",
      name: isEn ? "ANGEL" : "あんじ",
      scroll: 7400,
    },
  ];

  React.useEffect(() => {
    const lang = localStorage.getItem("lang");
    lang === "jp" ? setlanguage("jp") : setlanguage("en");
  }, [language]);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setlanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const LinkVoting = () => {
    window.open("https://citypoptokyo.deform.cc/voting/?page_number=0", "_blank");
  };

  const handleClick = () => {
    window.open("https://city-pop.tokyo/", "_blank");
  };

  return (
    <>
      <div className="flex flex-col bg-white max-w-[1600px] mx-auto ">
        <div className="flex relative gap-2 justify-between px-20 py-3 w-full bg-purple-500 max-md:flex-wrap max-md:px-5 max-md:max-w-full">
          <Image
            loading="lazy"
            src={logo}
            alt="Descriptive alt text for the first image"
            className="shrink-0 max-w-full aspect-[2.13] w-[171px] cursor-pointer"
            onClick={handleClick}
          />
          <div className="flex gap-4">
            <div className="flex m-auto language">
              <LanguageIcon className="lang-icon" />
              <button
                className={`button ${language !== "jp" ? "active" : ""}`}
                type="button"
                onClick={() => changeLanguage("jp")}
              >
                JP
              </button>
              <span className="devider"> / </span>
              <button
                className={`button !mr-2.5 ${
                  !language.includes("en") ? "active" : ""
                }`}
                type="button"
                onClick={() => changeLanguage("en")}
              >
                EN
              </button>
            </div>
            <Image
              src={language === "en" ? buttonVoteEn : buttonVote}
              alt="Descriptive alt text for the second image"
              className="shrink-0 my-auto max-w-full aspect-[4.55] w-[293px] cursor-pointer"
              onClick={LinkVoting}
            />
          </div>
        </div>
        <section
          className="flex relative flex-col w-full max-md:pl-5 max-md:max-w-full bg-top"
          style={{
            background: `url(${bgTop})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "0px",
          }}
        >
          <div className="relative self-center mt-3 w-full max-md:max-w-full pt-12 top-wrapper">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-[36%] max-md:ml-0 max-md:w-full">
                <div className="flex relative flex-col max-md:mt-10 max-md:max-w-full">
                  <div className="w-[299px] text-center">
                    <Image
                      src={logoMeta}
                      alt=""
                      className="max-w-full top-logo"
                    />
                    <div className="flex gap-3 justify-center mr-5">
                      <span className="hiragino text-white">Powered by</span>
                      <img className="w-24" src={gemieLogo} alt="gemie" />
                    </div>
                  </div>
                  <h2 className="top-decides text-3xl font-bold text-black max-md:mt-10 max-md:max-w-full hiragino">
                    {t("top_vode_decides")}
                  </h2>
                  <div className="top-nft-talent bestten justify-center w-fit px-4 pt-1 pb-3 mt-9 font-bold text-white bg-purple-500 border-white border-solid max-md:px-5 max-md:max-w-full">
                    {t("top_nft_talent")}
                  </div>

                  <Image
                    src={language === "en" ? titleEn : title}
                    alt=""
                    className="w-[525px] top-finals"
                  />
                  <div className="flex gap-5 mt-8 font-semibold text-black max-md:flex-wrap">
                    <div className="top-periode self-start text-white text-lg m-auto bg-[#FF00FF] px-3">
                      {t("top_periode")}
                    </div>
                    <div className="top-periode-date hiragino font-semibold flex-auto text-3xl">
                      2024.5.29~6.5
                    </div>
                  </div>
                  <div className="relative">
                    <Image
                      src={language === "en" ? buttonVoteEn : buttonVote}
                      alt="Descriptive alt text for the second image"
                      className="shrink-0 mt-4 max-w-full w-[293px] cursor-pointer top-button-vote"
                      onClick={LinkVoting}
                    />
                    <div className="wrapper pl-28 xl:pt-[60%] pt-[40%]">
                      <div className="ratio">
                        <div className="arrow">
                          <div className="arrow-wrapper">
                            <div className="arrow-top arrow-team">
                              <span></span>
                              <span></span>
                              <span></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid flex-col ml-5 w-[64%] max-md:ml-0 max-md:w-full justify-end">
                <div className="flex relative grow gap-5 items-start max-md:flex-wrap">
                  <Image src={userList} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="audition-wrapper flex flex-col mt-11 w-full max-md:mt-10 max-md:max-w-full">
          <div className="z-10 self-center w-full max-md:max-w-full relative">
            {/* <div className="arrow-wrapper absolute -top-28 left-28">
              <div className="arrow-team">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div> */}

            <div className="flex gap-5 justify-center relative mb-11">
              <div className="flex flex-col max-md:ml-0 max-md:w-full">
                <div className="grid flex-col text-center max-md:max-w-full justify-end">
                  <div className="self-center text-4xl font-semibold max-md:mt-10 max-md:max-w-full gap-3 grid">
                    <Image
                      src={audition}
                      alt=""
                      className={"m-auto w-48 mb-6"}
                    />
                    {t("audition_talent")}
                    <br />
                    <span className="text-white px-3 py-1 bg-purple-500">
                      {t("audition_decide")} {t("audition_voting")}
                    </span>
                  </div>
                </div>
              </div>
              <Image
                src={mic}
                alt=""
                className="absolute right-5 -top-5 audition-mic"
              />
            </div>
          </div>
          <div className="mx-3.5 mt-0 max-md:mr-2.5 max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                <Image
                  src={bgAudition}
                  alt=""
                  className="grow w-full aspect-[1.61] max-md:mt-10 max-md:max-w-full"
                />
              </div>
              <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow mt-3.5 text-black max-md:mt-10 max-md:max-w-full">
                  <h3 className="text-3xl font-semibold max-md:max-w-full">
                    {t("audition_winner")}
                    <br />
                    {t("audition_original")}
                    <br />
                    {t("audition_citypop")}
                  </h3>
                  <p className="mt-6 text-lg max-md:max-w-full font-semibold">
                    {t("audition_content1")}
                    {t("audition_content2")}
                    <br />
                    {t("audition_content3")}
                    <br />
                    <br />
                    {t("audition_content4")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Image
            src={language === "en" ? bgFlowEn : bgFlow}
            alt=""
            className="grow w-full h-48 my-12"
          />
        </section>
        <section className="flex overflow-hidden relative flex-col justify-center mt-20 w-full min-h-[664px] max-md:mt-10 max-md:max-w-full">
          <Image
            src={bgWinner}
            alt=""
            className="object-cover absolute inset-0 size-full"
          />
          <div className="finalist-wrapper flex relative justify-center items-center px-16 py-14 max-md:px-5 max-md:max-w-full">
            <div className="flex flex-col items-center w-full max-w-[1196px] max-md:max-w-full">
              <Image src={finalist} alt="" className={"m-auto w-48 mb-6"} />
              <div className="flex gap-5 justify-between self-stretch mt-8 max-md:flex-wrap">
                {finalists.map((finalist, index) => (
                  <Finalist
                    key={finalist.name}
                    index={index}
                    {...finalist}
                    language={language}
                  />
                ))}
              </div>
              <Image
                src={language === "en" ? buttonVoteEn : buttonVote}
                alt=""
                className={"m-auto w-48 mb-6 cursor-pointer"}
                onClick={LinkVoting}
              />
            </div>
          </div>
        </section>
        <section
          className="p-12"
          style={{
            background: `url(${bgPreview})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <Profile language={language} />
        </section>
      </div>

      <Footer />
    </>
  );
}

export default HomeMobile;
